import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Preloader, Topbar, Header, Footer, BackToTop } from '@components/layout';
import { HomePage, ContactPage, ReviewPage } from '@pages';
import { usePreloader } from '@hooks';
import '@styles/main.css';
import '@styles/modal.css';

function App() {
  const isLoading = usePreloader();

  return (
    <Router>
      <div id="top">
        <Preloader isLoading={isLoading} />
        <Topbar />
        <Header />
        
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/review" element={<ReviewPage />} />
        </Routes>

        <Footer />
        <BackToTop />
      </div>
    </Router>
  );
}

export default App;
